<script lang="ts" setup>
</script>
<template>
  <div class="c-divider" />
</template>
<style scoped>
.c-divider {
  height: 1px;
  flex: 0 0 auto;
  background-color: rgb(0 0 0 / 12%);
}
</style>
